export const manageBooleanFieldWithString = (value) => {
  const trueValues = ["true", "1", "True"];

  if (value === "" || value === null || value === undefined) {
    return null;
  }
  if (typeof value === "string" && value.length > 0) {
    return trueValues.includes(value);
  }
};

export const getStringFromArray = (array) => {
  if (!Array.isArray(array)) {
    return "";
  }
  return array.join(", ");
};

export const truncateText = (text, maxLength = 60) => {
  if (typeof text !== "string") {
    return "";
  }
  return text.length > maxLength ? text.slice(0, maxLength - 3) + "..." : text;
};

export const getTruncatedStringFromArray = (array, index, t, maxLength = 60) => {
  if (index !== 0 || !Array.isArray(array) || array.length === 0) {
    return "";
  }
  const label = array.map((text) => t(text)).join(", ");
  return truncateText(label, maxLength);
};

export const handleMultipleChoiceFields = (form, choices, multipleFields) => {
  multipleFields.forEach((field) => {
    if (field in choices.value && Array.isArray(choices.value[field])) {
      const values = choices.value[field].map((item) => item.value);
      form.value[field] = [...new Set(values.flat())];
    }
  });

  return form.value;
};

export const getBoolAsString = (value) => {
  if (value === null || value === undefined) {
    return " - ";
  }
  if (value === false || value === "false" || value === "0") {
    return "no";
  }
  return "yes";
};

export const formatDecimal = (value, maxDecimals = 6, fallback = "-") => {
  if (value === null || value === undefined || value === "") {
    return fallback;
  }
  const number = Number(value);
  return Number.isNaN(number) ? fallback : String(Number(number.toFixed(maxDecimals)));
};

export const handleRadioButtonsFields = (form, choices, radioFields) => {
  radioFields.forEach((field) => {
    if (field in choices.value && Array.isArray(choices.value[field])) {
      const values = choices.value[field]
        .map((item) => (typeof item === "object" ? item.value : item))
        .filter((val) => val !== undefined && val !== null);
      if (values.length > 0) {
        const firstValue = values[0];
        const allSame = values.every((val) => val === firstValue);
        if (allSame) {
          form.value[field] = firstValue;
        }
      }
    }
  });

  return form.value;
};
